"use client";

import { useQuery } from "@tanstack/react-query";
import { getOrigins } from "@/features/origins";
import { useAuth } from "@/state/globalStore";
import { thoughtKeys } from "./keys";

export default function useTraceOriginQuery(
  originId?: string | null,
  { enabled = true }: { enabled?: boolean } = {},
) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: thoughtKeys.traceOrigin(originId),
    queryFn: async () => {
      if (!originId) {
        return null;
      }

      const origins = await getOrigins(accessToken, {
        origin_ids: [originId],
        limit: 1,
      });

      return origins[0] ?? null;
    },
    enabled: enabled && Boolean(accessToken) && Boolean(originId),
  });
}
